(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["compte-a-rebours"] && !Shopify.designMode) return;
  try {
    class HbCountdown extends HTMLElement {
    connectedCallback() {
      this.target = new Date(this.dataset.target).getTime();
      this.live = this.querySelector('[data-role="live"]');
      this.done = this.querySelector('[data-role="done"]');
      this.units = this.querySelector('[data-role="units"]');

      // Date illisible (saisie erronée) : on laisse le repli serveur en
      // place plutôt que d'afficher un compteur faux.
      if (!this.target || Number.isNaN(this.target)) return;

      if (this.units) this.units.hidden = false;

      this.values = {};
      this.querySelectorAll('[data-unit]').forEach((el) => {
        this.values[el.dataset.unit] = el.querySelector('[data-value]');
      });

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    finish() {
      clearInterval(this.interval);
      this.classList.remove('hb-countdown--running');
      if (this.units) this.units.hidden = true;
      if (this.live) this.live.hidden = true;
      if (this.done) this.done.hidden = false;
    }

    tick() {
      let diff = this.target - Date.now();
      if (diff <= 0) {
        this.finish();
        return;
      }

      this.classList.add('hb-countdown--running');
      if (this.live) this.live.hidden = false;
      if (this.done) this.done.hidden = true;

      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;
      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;
      const minutes = Math.floor(diff / 60000);
      diff -= minutes * 60000;
      const seconds = Math.floor(diff / 1000);

      // Les jours ne sont pas complétés par un zéro : « 2 » se lit mieux
      // que « 02 » quand il reste deux jours.
      this.set('days', String(days));
      this.set('hours', String(hours).padStart(2, '0'));
      this.set('minutes', String(minutes).padStart(2, '0'));
      this.set('seconds', String(seconds).padStart(2, '0'));
    }

    set(unit, value) {
      const el = this.values[unit];
      if (el && el.textContent !== value) el.textContent = value;
    }
  }

  if (!customElements.get('hb-countdown')) {
    customElements.define('hb-countdown', HbCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
